function ImageCard({ image }) {
  const tags = image.tags.split(',');

  return (
    <div className=" rounded mx-10 overflow-hidden shadow-lg border-solid border-2 border-sky-500 mb-10 transition-all hover:scale-110 lg:mx-0 lg:mx-5 lg:p-3">
      <img src={image.webformatURL} alt="pixabay" className="w-full" />
      <div className="px-6 py-4">
        <div className="font-bold text-teal-900 text-xl mb-2 flex flex-wrap justify-between ">
          <a href={image.pageURL} target="_blank" rel="noreferrer">
            <span className="underline underline-offset-2 hover:text-purple-800">
              Image by {image.user}
            </span>
          </a>
          <span className="border-4 rounded-full border-blue-600 overflow-hidden  profile-pic ml-auto">
            <img
              src={image.userImageURL}
              alt="user profile "
              className="rounded-full"
            />
          </span>
        </div>
        <div className="flex justify-between">
          <ul>
            <li>
              <strong>Views:</strong> {image.views}
            </li>
            <li>
              <strong>Downloads:</strong> {image.downloads}
            </li>
            <li>
              <strong>Likes:</strong> {image.likes}
            </li>
          </ul>
          <a href={image.webformatURL}>
            <button className=" bg-teal-700 hover:bg-blue-600 text-md text-white rounded transition-all px-3 py-1 rounded-full mt-6">
              Full Image
            </button>
          </a>
        </div>

        <div className="px-2 py-4">
          {tags.map((tag, index) => {
            return (
              <span
                key={index}
                className="inline-block bg-gray-200 rounded-full px-3 py-1 text-sm font-semibold text-gray-700 mr-2 mt-2 hover:text-white hover:bg-blue-800 hover:cursor-pointer"
              >
                #{tag}
              </span>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default ImageCard;
